var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"contrast",attrs:{"viewBox":"0 0 32 32"}},[_c('path',{attrs:{"d":"M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zM4 16c0-6.627 5.373-12 12-12v24c-6.627 0-12-5.373-12-12z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }